import { isEmpty } from 'lodash';
import React, { useState } from 'react'
import { connect } from 'react-redux';
import { DIAGNOSIS_TYPE, SLAVES_DIAGNOSIS, SLAVES_TREATMENT, TREATMENT_TYPE } from '../../constants';
import Form from './form';
import FieldGroupForm from './FieldGroupForm';
import MissingRequiredFieldsModal from './MissingRequiredFieldsModal';
import { buildFieldGroupEditPayload, findMissingRequiredFields, forwardedOptions, hydrateFieldGroupEdit, instanceSelectorOptions, isSubformGroup, missingFieldAnchorId } from '../../utils/fieldGroupEdit';

export default function SectionForm(props) {
    const dictFields = {};
    const preString = "field_";
    const sectionStart = "title_section_";
    let initialData = {}; //props.initData ? props.initData : null;

    const fieldGroups = props.fieldGroups || [];
    // SKIN-536: field-group values are React state hydrated ONCE from initData. They used to
    // be rebuilt from initData on every render, so any re-render reset unsaved edits.
    const [fieldGroupEdit, setFieldGroupEdit] = useState(() => hydrateFieldGroupEdit(fieldGroups, props.initData));
    // Required fields left empty on the last save attempt; non-empty opens the modal (SKIN-536).
    const [missingRequired, setMissingRequired] = useState([]);

    props.fields.forEach(field => {

        let copyField = Object.assign({}, field);
        const preText = field.type === "title_section_" ? sectionStart : preString;
        copyField["name"] = preText+field.id.toString();


        if (field.type === "treatment_inpatient") {
            copyField.fieldInfo = field;
            copyField.idSubmission = props.idSubmission;
            copyField.onSaveToDatabase = props.onSaveToDatabase;
            copyField.onUpdateDatabase = props.onUpdateDatabase;
            copyField.onDeleteDatabase = props.onDeleteDatabase;
        }

        dictFields[preString+field.id.toString()] = copyField;
        if(props.initData){
            const record = (props.initData.surveyRecords || []).find(record => record.surveyField.id === field.id);
            if(record){
                if(Array.isArray(record.value) ){
                    console.log("Es un array!");
                }
                initialData[preString+field.id.toString()] = Array.isArray(record.value) ? [...record.value] : record.value;
            }
        }
    });

    function handleFieldGroupChange(fieldGroupId, instances) {
        setFieldGroupEdit(prev => ({ ...prev, instances: { ...prev.instances, [fieldGroupId]: instances } }));
    }

    function handleSubformChange(optionId, subform) {
        setFieldGroupEdit(prev => ({ ...prev, subforms: { ...prev.subforms, [String(optionId)]: subform } }));
    }

    function jumpToMissingField(field) {
        setMissingRequired([]);
        const element = document.getElementById(missingFieldAnchorId(field));
        if (!element) return;
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const input = element.querySelector('input, textarea, button, [tabindex]:not([tabindex="-1"])');
        if (input) input.focus({ preventScroll: true });
    }

    function callBackForm(values, buttonSubmitted){
        let copyValues = Object.assign({}, values)
        const dataFields = [];
        Object.keys(values).forEach(key =>{
            if(!key.includes(sectionStart)){
                const idField = parseInt(key.replace(preString, ""));
                const surveyField = props.fields.find(field => field.id === idField);

                dataFields.push({
                    surveyField : {...surveyField},
                    value : values[key]
                });
            }
        })

        // Validate required fields in field group instances (visible, editable ones only)
        const sectionsForValidation = props.sections || [{ fieldGroups }];
        const missing = findMissingRequiredFields(sectionsForValidation, fieldGroupEdit);
        if (missing.length > 0) {
            setMissingRequired(missing);
            return;
        }

        // The update endpoint replaces field groups wholesale, so this carries back every
        // stored group the form did not render, plus flat-stored groups as ungrouped records.
        const { surveyRecords: groupRecordsStoredFlat, fieldGroups: fieldGroupPayload } =
            buildFieldGroupEditPayload(fieldGroups, fieldGroupEdit, props.initData);
        dataFields.push(...groupRecordsStoredFlat);

        props.callBackSectionForm(dataFields, buttonSubmitted, fieldGroupPayload);
    }

    return (
        <>
            <Form fields={dictFields} initialData={initialData} country={props.country}
                uuidSurvey={props.uuidSurvey} alterSubmitButton={props.alterSubmitButton}
                department={props.department}
                uuidInvestigation={props.uuidInvestigation} uuidPatient={props.uuidPatient}
                submitText={Object.keys(initialData).length > 0 ? "general.update" : null}
                idSubmission={props.idSubmission}
                hideButtonsSubmit={props.hideButtonsSubmit}
                onSaveToDatabase={props.onSaveToDatabase}
                onUpdateDatabase={props.onUpdateDatabase}
                onDeleteDatabase={props.onDeleteDatabase}
                callBackForm = {(values, buttonSubmitted) => callBackForm(values, buttonSubmitted)}>
            </Form>
            {fieldGroups.filter(fg => fg.isActive && !isSubformGroup(fg)).map(fg => (
                <FieldGroupForm
                    key={fg.id}
                    fieldGroup={fg}
                    instances={fieldGroupEdit.instances[fg.id] || []}
                    country={props.country}
                    uuidPatient={props.uuidPatient}
                    uuidInvestigation={props.uuidInvestigation}
                    uuidSurvey={props.uuidSurvey}
                    onChange={(instances) => handleFieldGroupChange(fg.id, instances)}
                    subforms={fieldGroupEdit.subforms}
                    onSubformChange={handleSubformChange}
                    resolveForwardedOptions={(field) => forwardedOptions(field, fieldGroupEdit, props.initData)}
                    resolveInstanceOptions={(field) => instanceSelectorOptions(field, props.initData, props.sections || [{ fieldGroups }])}
                />
            ))}
            <MissingRequiredFieldsModal
                open={missingRequired.length > 0}
                missing={missingRequired}
                onJumpTo={jumpToMissingField}
                onClose={() => setMissingRequired([])}
            />
        </>
    )
}
